import { gql } from '@apollo/client';
import { workPackageFragments } from '../work-packages';

const fragments = {
  plannedToGoMilestones: gql`
    fragment PlannedToGoMilestonesStats on WorkPackageStats {
      plannedToGoMilestones {
        id
        numMilestones
        hours
        quantity {
          ...Quantity
        }
      }
    }
    ${workPackageFragments.quantity}
  `,
  plannedMilestones: gql`
    fragment PlannedMilestonesStats on WorkPackageStats {
      plannedMilestones {
        id
        numMilestones
        hours
        quantity {
          ...Quantity
        }
      }
    }
    ${workPackageFragments.quantity}
  `,
  earnedMilestones: gql`
    fragment EarnedMilestoneStats on WorkPackageStats {
      earnedMilestones {
        id
        numMilestones
        hours
        quantity {
          ...Quantity
        }
      }
    }
    ${workPackageFragments.quantity}
  `,
  approvedMilestones: gql`
    fragment ApprovedMilestoneStats on WorkPackageStats {
      approvedMilestones {
        id
        numMilestones
        hours
        quantity {
          ...Quantity
        }
      }
    }
    ${workPackageFragments.quantity}
  `,
  progress: gql`
    fragment ProgressDetails on WorkPackageStats {
      progress {
        approvedHours
        approvedQuantity {
          ...Quantity
        }
        committedHours
        committedQuantity {
          ...Quantity
        }
        claimedHours
        claimedQuantity {
          ...Quantity
        }
        targetHours
        targetQuantity {
          ...Quantity
        }
      }
    }
    ${workPackageFragments.quantity}
  `,
};

export const DASHBOARD_STATS = gql`
  query workPackageStats($input: WorkPackageStatsInput!) {
    workPackageStats(input: $input) {
      numWorkPackages
      numBlocks
      numRejects
      crew {
        numCrews
        numCrewMembers
      }
      ...ProgressDetails
      ...PlannedToGoMilestonesStats
      ...PlannedMilestonesStats
      ...EarnedMilestoneStats
      ...ApprovedMilestoneStats
      committedMilestones {
        id
        numMilestones
        hours
        quantity {
          ...Quantity
        }
      }
    }
  }
  ${workPackageFragments.quantity}
  ${fragments.progress}
  ${fragments.plannedToGoMilestones}
  ${fragments.plannedMilestones}
  ${fragments.earnedMilestones}
  ${fragments.approvedMilestones}
`;

export const GET_DASHBOARD_STATS_POST_CLAIM = gql`
  query workPackageStats($input: WorkPackageStatsInput!) {
    workPackageStats(input: $input) {
      numRejects
      ...ProgressDetails
      ...PlannedToGoMilestonesStats
      ...PlannedMilestonesStats
      ...EarnedMilestoneStats
      ...ApprovedMilestoneStats
    }
  }
  ${fragments.progress}
  ${fragments.plannedToGoMilestones}
  ${fragments.plannedMilestones}
  ${fragments.earnedMilestones}
  ${fragments.approvedMilestones}
`;

export const TARGET_HOURS_CALCULATION = gql`
  query targetHoursCalculation($input: TargetHoursCalculationInput!) {
    targetHoursCalculation(input: $input) {
      crewHeadCount
      weeklyHours
      crewHours
      indirectTax
      indirectHours
      projectAdjustmentFactor
      projectAdjustmentHours
      compositeUnitRate {
        unitRate
      }
    }
  }
`;

export const GET_DRAWING_LIST = gql`
  query drawingList($input: CommodityFilterInput, $paging: PagingInput) {
    commodities(input: $input, paging: $paging) {
      total
      items {
        weld {
          id
          isoDocument {
            documentNumber
          }
        }
      }
    }
  }
`;

export const GET_CREW_PROGRESS_STATS = gql`
  query crewProgressStats($input: CrewProgressStatsInput!, $paging: PagingInput) {
    crewProgressStats(input: $input, paging: $paging) {
      cursor
      total
      crewMemberId
      items {
        crewMemberId
        crewMember {
          id
          firstName
          lastName
          persona
          imageUrl
          badgeNumber
        }
        commodityStatusStats(input: $input) {
          stats
          status
        }
        # numRodRequests(input: $input)
        # hasExpiredRodRequest
      }
    }
  }
`;
